import axios from 'axios';

const instance = axios.create({
    baseURL: checkEnvironment(process.env.NODE_ENV),
    timeout: 30000,
    //  baseURL:'http://platform-platform-frontend.test/api/',
});

function checkEnvironment(env) {
    switch (env) {
        case 'development':
            return 'https://api.smoothylang.org/api/';
        case 'staging':
            return 'https://api.smoothylang.org/api/';
        case 'production':
            return 'https://api.hellocode.me/api/';
    }
}

export default instance;



// WEBPACK FOOTER //
// ./src/store/axios-auth.js